// extracted by mini-css-extract-plugin
export default {"wrapper":"my-z","viewport":"ny-z","container":"oy-z","slide":"py-z"};